import 'globals';

(function(window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        const toTopButton = document.createElement('button');
        toTopButton.title = 'Zum Seitenanfang';
        toTopButton.type = 'button';
        toTopButton.classList.add('btn', 'scroll-btn', 'to-top');
        toTopButton.innerHTML = '<i class="ai ai-chevron-up"></i>';
        toTopButton.style.display = 'none';

        const toBottomButton = document.createElement('button');
        toBottomButton.title = 'Zum Seitenende';
        toBottomButton.type = 'button';
        toBottomButton.classList.add('btn', 'scroll-btn', 'to-bottom');
        toBottomButton.innerHTML = '<i class="ai ai-chevron-down"></i>';
        toBottomButton.style.display = 'none';

        document.body.appendChild(toTopButton);
        document.body.appendChild(toBottomButton);
        document.body.classList.remove('scroll-to-top-show');

        window.addEventListener('scroll', () => {
            if (window.scrollY > 100) {
                document.querySelectorAll('.scroll-btn').forEach(function (el) {
                    el.style.display = 'block';
                });
                document.body.classList.add('scroll-to-top-show');
            } else {
                document.querySelectorAll('.scroll-btn').forEach(function (el) {
                    el.style.display = 'none';
                });
                document.body.classList.remove('scroll-to-top-show');
            }
        });

        toTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
        }, {passive: true})

        toBottomButton.addEventListener('click', () => {
            document.querySelector('footer:has(.footerMenu)').scrollIntoView();
        }, {passive: true})
    });
})(window, document, window.PageLoadedQueue);
